module.exports = __webpack_public_path__ + "img/title2-2.a8a84499.png";